import client from '/src/services/client.js';

export default {
    //getIntegrations : (data) => client.get(`integrations`,data),
    getIntegrationsIvy: (data) => client.get(`integrations`,{...data, ...{type : 0}}),
    getIntegrationsWorksheet: (data) => client.get(`integrations`,{...data, ...{type : 2}}),
    getIntegrationsMcp: (data) => client.get(`integrations`,{...data, ...{type : 3}}),
    addIntegration : (data)=> client.post(`integration`, data),
    deleteIntegration : (name,data)=> client.delete(`integration/${name}`,data),
    updateIntegration : (id,data)=> client.put(`integration/${id}/update`, data),

    getIntegration : (name)=> client.get(`${name}/integration`),
}